import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20geometric%20shapes%20and%20soft%20flowing%20lines%20in%20amber%20coral%20and%20cream%20tones%20modern%20minimalist%20digital%20art%20with%20subtle%20texture%20and%20organic%20patterns%20evoking%20innovation%20and%20creativity%20warm%20inviting%20atmosphere%20clean%20aesthetic&width=1600&height=900&seq=wuma-hero-bg&orientation=landscape"
        alt="无码开发平台背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center max-w-4xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-sm font-medium mb-6 border border-white/20">
          新一代低代码 / 无码开发平台
        </span>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          无需编写代码
          <br />
          <span className="text-primary-400">创造无限可能</span>
        </h2>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          无码帮助企业和个人快速搭建应用、自动化流程与数字化系统，
          极大降低开发门槛，让业务效率实现质的飞跃。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/about#contact"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            免费开始使用
          </a>
          <Link
            to="/category/app-building"
            className="px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-base border border-white/30 hover:bg-white/25 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            探索应用场景
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-8 max-w-lg mx-auto">
          {[
            { number: '100,000+', label: '活跃用户' },
            { number: '500万+', label: '应用已创建' },
            { number: '99.9%', label: '服务可用性' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.number}</div>
              <div className="text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}